import { useNavigate, useParams } from "react-router-dom";
import MainContainer from "../../layout/MainContainer";
import usePagination from "@mui/material/usePagination/usePagination";
import { useEffect, useState } from "react";
import { useLazyGetUsersByIdQuery } from "../../services/customer";
import { showError } from "../../constants/toasts";

const SubadminDetail = () => {

  const navigate = useNavigate();
  const { id } = useParams()
  const [loading, setLoading] = useState<boolean>()
  const [getById] = useLazyGetUsersByIdQuery()
  const [data, setData] = useState<any>()

  const fetchUser = async () => {
    try {
      if (!id) return;
      setLoading(true)
      const res = await getById({ id }).unwrap();
      if (res?.statusCode === 200) {
        setData(res?.data)
      }
    } catch (error: any) {
      showError(error?.data?.message || error?.message)
    } finally {
      setLoading(false)
    }
  }


  useEffect(() => {
    if (id) {

      fetchUser()
    }
  }, [])
  return (
    <MainContainer>
      <div className="main_title">
        <h1>Sub-Admin Detail</h1>
        <p>
          <span onClick={() => navigate("/dashboard")}>Dashboard</span>
          {' '} - <span onClick={() => navigate("/manage-subadmin")}>Manage Sub-Admin</span>
          {' '} - Sub-Admin Detail
        </p>
      </div>

      <div className="cards view_page">
        <div className="gap_p">
          <div className="vew_img w_100">
            <h6>Image</h6>
            <figure>
              <img alt="user" src={data?.image || "/static/images/user_placeholder.png"} />
            </figure>
          </div>
          <div className="w_33">
            <h6>Name</h6>
            <p>
              {loading ? "Loading..." : ([data?.firstName, (data as any)?.lastName].filter(Boolean).join(" ") || "-")}
            </p>
          </div>
          <div className="w_33">
            <h6>Role</h6>
            <p>
              {data?.accessRoleId?.name || "-"}
            </p>
          </div>
          <div className="w_33">
            <h6>Email Id</h6>
            <p>{loading ? "Loading..." : (data?.email || "-")}</p>
          </div>
          <div className="w_33">
            <h6>Phone Number</h6>
            <p>{loading ? "Loading..." : (data?.phoneNumber || "-")}</p>
          </div>
          <div className="w_33">
            <h6>Created Date</h6>
            <p>
              {loading
                ? "Loading..."
                : (data?.createdAt ? new Date(data.createdAt).toLocaleDateString() : "-")}
            </p>
          </div>
        </div>
      </div>
    </MainContainer>
  );
};

export default SubadminDetail;
